import React from "react";
import { Box, Chip, Typography } from "@mui/material";
import ImportarPlanilhaDialog, { formatCpfCnpj, formatTelefone } from "../../components/ImportarPlanilhaDialog";
import { FornecedorService } from "../../service/fornecedor_service";
import { baixarModeloImportacao, lerPlanilhaFornecedores } from "../../utils/importacaoFornecedores";

/**
 * Colunas da prévia comuns a fornecedores e clientes (o cadastro é o mesmo).
 * `produtos` vem do backend já casado com os cultivos.
 */
export const COLUNAS_PREVIA_CADASTRO = [
	{
		rotulo: "Nome",
		render: (l) => (
			<>
				<Typography variant="body2" sx={{ fontWeight: 500 }}>{l.dados.nome || "-"}</Typography>
				{l.dados.nomeFantasia && (
					<Typography variant="caption" sx={{ color: "#5a7a88", display: "block" }}>{l.dados.nomeFantasia}</Typography>
				)}
			</>
		),
	},
	{ rotulo: "CPF/CNPJ", sx: { whiteSpace: "nowrap" }, render: (l) => formatCpfCnpj(l.dados.cpfCnpj) },
	{ rotulo: "Telefone", sx: { whiteSpace: "nowrap" }, render: (l) => formatTelefone(l.dados.telefone) },
	{
		rotulo: "Cidade/UF",
		render: (l) => (l.dados.cidade || l.dados.uf ? [l.dados.cidade, l.dados.uf].filter(Boolean).join(" - ") : "-"),
	},
	{
		rotulo: "Produtos",
		render: (l) =>
			(l.dados.produtos || []).length ? (
				<Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
					{l.dados.produtos.map((p) => (
						<Chip key={p.cultivoId} size="small" label={p.descricao} variant="outlined" sx={{ borderColor: "#dfe3e8", color: "#0f4557" }} />
					))}
				</Box>
			) : (
				"-"
			),
	},
];

function ImportarFornecedoresDialog({ open, onClose, onImportado, unidadeDistribuidoraId }) {
	const service = new FornecedorService();
	return (
		<ImportarPlanilhaDialog
			open={open}
			onClose={onClose}
			onImportado={onImportado}
			titulo="Importar fornecedores de planilha"
			entidade={{ singular: "fornecedor", plural: "fornecedores", contagem: "fornecedor(es)" }}
			instrucoes={
				<>
					<Typography variant="body2" sx={{ color: "#5a7a88" }}>
						Colunas obrigatórias: <strong>Nome</strong> e <strong>CPF/CNPJ</strong>. Opcionais: Nome Fantasia,
						IE/RG, E-mail, Telefone, CEP, UF, Cidade, Bairro, Logradouro, Latitude, Longitude, Data de entrada
						na base, Previsão de pagamento (dias) e Produtos.
					</Typography>
					<Typography variant="body2" sx={{ color: "#5a7a88" }}>
						Em <strong>Produtos</strong>, separe por ponto e vírgula e use o nome do cultivo como está no sistema,
						com a unidade entre parênteses se quiser: <em>Alface - Crespa (kg); Tomate - Cereja (un)</em>. Produto
						sem correspondência no cadastro de cultivos não é vinculado e aparece como aviso na prévia.
					</Typography>
					<Typography variant="body2" sx={{ color: "#5a7a88" }}>
						Fornecedores com CPF/CNPJ já cadastrado nesta unidade não são duplicados: o cadastro atual é mantido
						como está. Antes de gravar, você confere linha a linha o que vai entrar.
					</Typography>
				</>
			}
			ler={lerPlanilhaFornecedores}
			baixarModelo={baixarModeloImportacao}
			previa={(linhas) => service.previaImportacao(unidadeDistribuidoraId, linhas)}
			importar={(linhas) => service.importar(unidadeDistribuidoraId, linhas)}
			colunas={COLUNAS_PREVIA_CADASTRO}
			textoAvisos="Algumas linhas têm avisos (em laranja): o fornecedor entra, mas o item citado fica de fora. Você pode corrigir a planilha e enviar de novo, ou completar depois no cadastro do fornecedor."
		/>
	);
}

export default ImportarFornecedoresDialog;
